import { Button, Nav } from "reactstrap";
import Logo from "./Logo";
import { Link, useHref } from "react-router-dom";
import { useEffect, useState } from "react";
import { Collapse } from "@mui/material";
import './sidebar.scss'
import textMk from "../js/textMk";
import { ChevronRight } from "@mui/icons-material";



function NavItem({ title, icon, submenu, href, active }) {

  return <div key={title}>
    <div className="nav-menu-item">
      <Link className={active && "active"} to={href} >
        <img src={icon} width={32} />
        <h6>{title}</h6>
        {submenu && <ChevronRight style={{ rotate: active ? "90deg" : "0deg" }} ></ChevronRight>}
      </Link>
    </div>
    {submenu &&
      <Collapse in={active}>
        {submenu.map((sub, index) => (
          <Link className={textMk("nav-submenu", sub.active && "active")} to={sub.href}>{index + 1}. {sub.title}</Link>
        ))}
      </Collapse>}
  </div>
}


// active = "AddCase" | "DraftCases"
const Sidebar = ({ active }) => {

  const href = useHref()
  const query = new URLSearchParams(window.location.search)

  const showMobilemenu = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
  };

  const onLogout = () => {
    // if (window.confirm('confirm logout')) {
    window.location.href = "/login"
    // }
  }


  const navigation = [
    {
      title: "Case",
      href: "/",
      active: ["NewCases", "Approved", "Rejected", "AddCase", "ViewCase"].includes(active),
      icon: '/assets/images/case.png',
      type: 'img',
      submenu: [
        { title: "New", href: "/", active: active == 'NewCases' },
        { title: "Approved", href: "/case/approved", active: active == 'Approved' },
        { title: "Rejected", href: "/case/rejected", active: active == 'Rejected' },
        { title: "Add Case", href: "/case/add", active: active == 'AddCase' },
      ]
    },
    {
      title: "My Fund",
      href: "/my-fund",
      active: href == '/my-fund',
      icon: '/assets/images/funds.png',
      type: 'img'
    },
    // {
    //   title: "Settings",
    //   href: "/badges",
    //   icon: require('../assets/images/settings.png'),
    //    type:'img',
    //    width:20,height:20
    // },
    // {
    //   title: "Profile",
    //   href: "/buttons",
    //   icon: "bi bi-hdd-stack",
    //    type:'icon',
    // },
    {
      title: "Users",
      href: "/users",
      active: href == '/users',
      icon: "bi bi-card-text",
      icon: '/assets/images/user.png',
      type: 'img'
    },
  ];


  return (
    <div className="sidebar-container">
      <div className="sidebar-items">
        <div className="d-flex align-items-center">
          <Logo />
          <span className="ms-auto d-lg-none">
            <Button
              close
              size="sm"
              className="ms-auto d-lg-none"
              onClick={() => showMobilemenu()}
            ></Button>
          </span>
        </div>
        <div className="pt-4 mt-2">
          <div className="nav-container">
            {navigation.map(NavItem)}
            <Button
              color="danger"
              tag="a"
              id="logout"
              className="mt-3 w-full"
              onClick={onLogout}
            >
              Logout
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;


